export default {
	project_name: 'Academia Pintuco',
	company_agency: 'Empresa / Tienda',
	no_company_agency_found: "Empresa / Tienda no encontrada",
	add_new_company:	"Agregar nueva Empresa / Tienda",
	about_the: 'Acerca de',
	state: 'Dpto/Prov/Est',
	profession: 'Perfil'
}
